export default __webpack_public_path__ + "static/media/ic_options.5a19351b.svg";